import { createSubscribableMutator } from '@famly/vet_apollo-utils_create-subscribable-mutator';
import { UpdateSubTypeIsRestrictedMutation } from './update-subtype-is-restricted.mutation';
export const { useSubscribableMutation: useUpdateSubTypeIsRestricted, useSubscribeMutationResult: useUpdateSubTypeIsRestrictedResult, } = createSubscribableMutator(UpdateSubTypeIsRestrictedMutation);
